<template lang="pug">
page-error(tooltip="Страница сломалась", code="404", alt="404 - Ничего не найдено")
	p Нам очень жаль, что так произошло. Мы обязательно исправим эту ошибку,
	p Извините, что недоглядели и спасибо за терпение.
	p
		br
		ext-button(color="green", size="medium" :factor="1.2" :rounded="true" :shadow="true" :to="{ path: '/' }") В каталог
</template>

<script>
import PageError from 'elysium-common/components/page/error';
import ExtButton from 'elysium-common/components/ext/Button.vue';

export default {
	components: {
		ExtButton,
		PageError
	},
	metaInfo: {
		title: 'Страница не найдена',
	}
};
</script>


// WEBPACK FOOTER //
// 404.vue?09166156